import { useDocumentsStore } from '@/store/documents'

export const isPathClickable = (path?: string) => {
  return path?.match(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/) !== null
}

export const getDocumentUrl = async (documentId: string): Promise<string> => {
  const documentsStore = useDocumentsStore()
  const result = await documentsStore.fetchSingle(documentId)
  if (!result.url) throw Error('Document URL is not available')
  return result.url
}
